import React, { Component } from 'react';
import { connect } from 'react-redux';
import axiosInstance from '../main/axios';
import MapaGoogle from '../mapa/mapaGoogle';
import { Marker } from 'react-google-maps';
import { coletarPinsFase } from './mapaFaseMarkerUtils';
import { chaveMarcadorControlador, rotuloControlador, subtituloControlador } from './mapaControladorMap';
import { rotuloStatusConexao, textoAneisControlador } from './mapaControladorCadastro';
import { getGrupoFisicoList } from '../common/selectdb/selectdbAtions';
import MapaControladorGavetaCameras from './mapaControladorGavetaCameras';

const INTERVALO_LIVE_MS = 1000;
const MINI_MAP_ZOOM = 17;

function centroDoControlador(controlador, fasesList) {
  const lat = Number(controlador && controlador.latitude);
  const lng = Number(controlador && controlador.longitude);
  if (Number.isFinite(lat) && Number.isFinite(lng)) {
    return { lat, lng };
  }
  const fase = (fasesList || []).find(f => f.fase_latitude != null && !Number.isNaN(parseFloat(f.fase_latitude, 10)));
  if (fase) {
    return { lat: parseFloat(fase.fase_latitude, 10), lng: parseFloat(fase.fase_longitude, 10) };
  }
  return { lat: -27.2, lng: -49.6 };
}

function rotuloGrupoFisico(controlador, gruposList) {
  const gid = controlador && controlador.grupo_fisico_id;
  if (gid == null || gid === '') return null;
  const g = (gruposList || []).find(x => Number(x.id) === Number(gid));
  if (g && g.descricao) return g.descricao;
  return String(gid);
}

class MapaControladorGaveta extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fasesList: [],
      carregando: true,
      erro: null,
      blinkOn: true,
      ultimaAtualizacao: null,
    };
    this.intervalLive = null;
    this.blinkInterval = null;
    this.carregarFases = this.carregarFases.bind(this);
  }

  componentDidMount() {
    if (!this.props.gruposList || !this.props.gruposList.length) {
      this.props.getGrupoFisicoList();
    }
    this.iniciarLeitura();
    this.blinkInterval = setInterval(() => {
      this.setState(prev => ({ blinkOn: !prev.blinkOn }));
    }, 500);
  }

  componentDidUpdate(prevProps) {
    const idAnt = prevProps.controlador && prevProps.controlador.controlador_id;
    const idNovo = this.props.controlador && this.props.controlador.controlador_id;
    if (idNovo && idNovo !== idAnt) {
      this.reiniciarLeitura();
    }
  }

  componentWillUnmount() {
    this.pararLeitura();
    if (this.blinkInterval) clearInterval(this.blinkInterval);
  }

  reiniciarLeitura() {
    this.pararLeitura();
    this.setState({ fasesList: [], carregando: true, erro: null }, () => this.iniciarLeitura());
  }

  iniciarLeitura() {
    const { controlador, grupoFisicoId } = this.props;
    if (!controlador || !grupoFisicoId) return;

    this.carregarFases();
    this.intervalLive = setInterval(this.carregarFases, INTERVALO_LIVE_MS);
  }

  pararLeitura() {
    if (this.intervalLive) {
      clearInterval(this.intervalLive);
      this.intervalLive = null;
    }
  }

  carregarFases() {
    const { controlador, grupoFisicoId } = this.props;
    const num = controlador.numero_controlador;
    if (num == null || !grupoFisicoId) return;

    axiosInstance
      .get(`/fasesgeral/mapa/${num}/0/${grupoFisicoId}`)
      .then(resp => {
        const lista = Array.isArray(resp.data) ? resp.data : [];
        this.setState({
          fasesList: lista,
          carregando: false,
          erro: null,
          ultimaAtualizacao: new Date(),
        });
      })
      .catch(err => {
        const msg =
          (err.response && err.response.data && err.response.data.errors && err.response.data.errors[0]) ||
          'Sem conexão com o controlador.';
        this.setState(prev => ({
          carregando: false,
          erro: msg,
          fasesList: prev.fasesList,
        }));
      });
  }

  renderMiniMapa() {
    const { controlador, googleMapsReady } = this.props;
    const { fasesList, blinkOn } = this.state;

    if (!googleMapsReady) {
      return (
        <div className="mapa-controlador-gaveta-mini-empty">
          <i className="fa fa-spinner fa-spin" /> Carregando mapa…
        </div>
      );
    }

    const centro = centroDoControlador(controlador, fasesList);
    const pins = coletarPinsFase(fasesList, { mapZoom: MINI_MAP_ZOOM, blinkOn });
    const mapKey = chaveMarcadorControlador(controlador);

    return (
      <div className="mapa-controlador-gaveta-mini-wrap">
        <MapaGoogle
          key={mapKey}
          containerElement={<div style={{ height: '100%', width: '100%' }} />}
          mapElement={<div style={{ height: '100%' }} />}
          defaultCenter={centro}
          defaultZoom={MINI_MAP_ZOOM}
          options={{ mapTypeControl: false, streetViewControl: false, fullscreenControl: false }}
        >
          {pins.map(pin => (
            <Marker key={pin.key} position={pin.position} icon={pin.icon} shape={pin.shape} />
          ))}
        </MapaGoogle>
      </div>
    );
  }

  render() {
    const { controlador, impactoCruzamento, onClose } = this.props;
    const { fasesList, carregando, erro, ultimaAtualizacao } = this.state;

    if (!controlador) return null;

    const titulo = rotuloControlador(controlador);
    const sub = subtituloControlador(controlador);
    const faseResumo = fasesList[0] || null;
    const nomeGrupo = rotuloGrupoFisico(controlador, this.props.gruposList);
    const statusCad = rotuloStatusConexao(controlador);

    return (
      <aside className="mapa-controlador-gaveta" role="dialog" aria-label={titulo}>
        <header className="mapa-controlador-gaveta-header">
          <div>
            <h3>{titulo}</h3>
            {sub ? <p className="mapa-controlador-gaveta-sub">{sub}</p> : null}
          </div>
          <button type="button" className="mapa-controlador-gaveta-close" onClick={onClose} aria-label="Fechar">
            ×
          </button>
        </header>

        <div className="mapa-controlador-gaveta-body">
          <div className="mapa-controlador-gaveta-cards-row">
            <section className="mapa-controlador-gaveta-card">
              <h4>Cadastro</h4>
              <dl className="mapa-controlador-gaveta-dl mapa-controlador-gaveta-dl--compact">
                <div>
                  <dt>Status</dt>
                  <dd>
                    <span
                      className={`mapa-controlador-gaveta-badge mapa-controlador-gaveta-badge--status ${
                        statusCad.online === true
                          ? 'is-online'
                          : statusCad.online === false
                          ? 'is-offline'
                          : 'is-neutro'
                      }`}
                    >
                      {statusCad.label}
                    </span>
                  </dd>
                </div>
                {controlador.endereco ? (
                  <div>
                    <dt>Endereço</dt>
                    <dd>{controlador.endereco}</dd>
                  </div>
                ) : null}
                {textoAneisControlador(controlador) ? (
                  <div>
                    <dt>Anéis</dt>
                    <dd>{textoAneisControlador(controlador)}</dd>
                  </div>
                ) : null}
                {controlador.numero_fases != null ? (
                  <div>
                    <dt>Fases</dt>
                    <dd>
                      {controlador.numero_fases}
                      {controlador.numero_fases_fim != null && controlador.numero_fases_fim !== controlador.numero_fases
                        ? ` a ${controlador.numero_fases_fim}`
                        : ''}
                    </dd>
                  </div>
                ) : null}
                {controlador.ip ? (
                  <div>
                    <dt>Comunicação</dt>
                    <dd>
                      {controlador.porta != null && controlador.porta !== ''
                        ? `${controlador.ip}:${controlador.porta}`
                        : controlador.ip}
                    </dd>
                  </div>
                ) : null}
                {nomeGrupo ? (
                  <div>
                    <dt>Grupo físico</dt>
                    <dd>{nomeGrupo}</dd>
                  </div>
                ) : null}
              </dl>
            </section>

            <section className="mapa-controlador-gaveta-card">
              <h4>Plano em execução</h4>
              {carregando && !faseResumo ? (
                <p className="mapa-controlador-gaveta-hint">
                  <i className="fa fa-spinner fa-spin" /> Lendo plano…
                </p>
              ) : (
                <dl className="mapa-controlador-gaveta-dl mapa-controlador-gaveta-dl--compact">
                  <div>
                    <dt>Plano atual</dt>
                    <dd>{faseResumo ? faseResumo.plano_atu || faseResumo.plano_id || '—' : '—'}</dd>
                  </div>
                  <div>
                    <dt>Próximo plano</dt>
                    <dd>{faseResumo ? faseResumo.plano_pro || faseResumo.hora_proximo_plano || '—' : '—'}</dd>
                  </div>
                </dl>
              )}
            </section>
          </div>

          {impactoCruzamento && impactoCruzamento.impacto ? (
            <section className="mapa-controlador-gaveta-section">
              <h4>Waze (raio do cruzamento)</h4>
              <p className="mapa-controlador-gaveta-waze-meta">
                {impactoCruzamento.tem_via_fechada || impactoCruzamento.impacto === 'via_fechada'
                  ? 'Via fechada'
                  : impactoCruzamento.impacto}
                {impactoCruzamento.jam_nivel_max ? ` · fila ${impactoCruzamento.jam_nivel_max}/5` : null}
              </p>
            </section>
          ) : null}

          <section className="mapa-controlador-gaveta-section mapa-controlador-gaveta-section--mapa">
            {erro ? <p className="mapa-controlador-gaveta-erro">{erro}</p> : null}
            {!erro && !carregando && !fasesList.length ? (
              <p className="mapa-controlador-gaveta-hint">Nenhuma fase retornada para este controlador.</p>
            ) : null}
            <div className="mapa-controlador-gaveta-mini-slot">{this.renderMiniMapa()}</div>
            {ultimaAtualizacao ? (
              <p className="mapa-controlador-gaveta-atualizado">
                Atualizado{' '}
                {ultimaAtualizacao.toLocaleTimeString('pt-BR', {
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                })}
              </p>
            ) : null}
          </section>

          <MapaControladorGavetaCameras controladorId={controlador.controlador_id} />
        </div>
      </aside>
    );
  }
}

const mapStateToProps = state => ({
  gruposList: state.grupoFisicoCad && state.grupoFisicoCad.list,
});

export default connect(
  mapStateToProps,
  { getGrupoFisicoList },
)(MapaControladorGaveta);
